// Lightweight state metadata for client components (~2KB vs 1.9MB rivers.ts).
// USMap + HomeSearch import this instead of STATES.

export interface StateEntry {
  name: string
  abbr: string
  slug: string
  riverCount: number
}

function toSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/['']/g, '')
    .replace(/\s*—\s*/g, '-')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

const RAW: [string, string, string, number][] = [
  ['mi', 'Michigan', 'MI', 67],
  ['wv', 'West Virginia', 'WV', 22],
  ['co', 'Colorado', 'CO', 22],
  ['id', 'Idaho', 'ID', 22],
  ['or', 'Oregon', 'OR', 28],
  ['wa', 'Washington', 'WA', 15],
  ['pa', 'Pennsylvania', 'PA', 36],
  ['mt', 'Montana', 'MT', 14],
  ['tn', 'Tennessee', 'TN', 25],
  ['ca', 'California', 'CA', 47],
  ['va', 'Virginia', 'VA', 30],
  ['ky', 'Kentucky', 'KY', 24],
  ['nc', 'North Carolina', 'NC', 35],
  ['az', 'Arizona', 'AZ', 8],
  ['wy', 'Wyoming', 'WY', 14],
  ['ut', 'Utah', 'UT', 17],
  ['nm', 'New Mexico', 'NM', 9],
  ['me', 'Maine', 'ME', 67],
  ['ny', 'New York', 'NY', 19],
  ['ga', 'Georgia', 'GA', 18],
  ['mn', 'Minnesota', 'MN', 38],
  ['wi', 'Wisconsin', 'WI', 33],
  ['ia', 'Iowa', 'IA', 46],
  ['mo', 'Missouri', 'MO', 27],
  ['ar', 'Arkansas', 'AR', 14],
  ['la', 'Louisiana', 'LA', 9],
  ['ms', 'Mississippi', 'MS', 8],
  ['al', 'Alabama', 'AL', 28],
  ['fl', 'Florida', 'FL', 37],
  ['sc', 'South Carolina', 'SC', 22],
  ['ne', 'Nebraska', 'NE', 11],
  ['sd', 'South Dakota', 'SD', 9],
  ['nd', 'North Dakota', 'ND', 7],
  ['ks', 'Kansas', 'KS', 10],
  ['ok', 'Oklahoma', 'OK', 8],
  ['tx', 'Texas', 'TX', 14],
  ['nv', 'Nevada', 'NV', 11],
  ['oh', 'Ohio', 'OH', 69],
  ['in', 'Indiana', 'IN', 26],
  ['il', 'Illinois', 'IL', 30],
  ['nh', 'New Hampshire', 'NH', 12],
  ['vt', 'Vermont', 'VT', 10],
  ['ct', 'Connecticut', 'CT', 17],
  ['ri', 'Rhode Island', 'RI', 12],
  ['nj', 'New Jersey', 'NJ', 8],
  ['de', 'Delaware', 'DE', 15],
  ['md', 'Maryland', 'MD', 11],
  ['ma', 'Massachusetts', 'MA', 10],
  ['ak', 'Alaska', 'AK', 61],
  ['hi', 'Hawaii', 'HI', 14],
  ['canada', 'Canada', 'CA', 13],
]

export const STATE_INDEX: Record<string, StateEntry> = {}
for (const [key, name, abbr, count] of RAW) {
  STATE_INDEX[key] = { name, abbr, slug: toSlug(name), riverCount: count }
}

export const STATE_KEYS = new Set(RAW.map(r => r[0]))

export function getStateSlug(stateKey: string): string {
  return STATE_INDEX[stateKey]?.slug ?? stateKey
}
